<template>
  <div id="application" :class="this.$store.getters.getSKUActivo" v-if="this.$store.getters.getPuenteDefault">
    <header id="header" class="section">
      <div class="container is-max-widescreen">
        <div class="columns is-mobile mb-0">
          <div class="column is-half has-text-left">
            <a href="https://istobal.com">
              <img
                  src="../assets/img/istobal-logo.png"
                  :alt="this.$i18n.t('general.istobal-logo')"
              >
            </a>
          </div>
          <div class="column is-4 is-offset-2 has-text-right" >
            <b-dropdown
                v-if="this.$store.getters.getLangs"
              v-model="localeselector"
              position="is-bottom-left"
              append-to-body
              aria-role="list">
              <template #trigger>
                  <a
                      class="navbar-item language pr-0"
                      role="button">
                    <b-icon
                        pack="fas"
                        icon="globe"
                        size="is-small">
                    </b-icon>
                    <span class="lang">{{$i18n.locale.toUpperCase()}}</span>
                  </a>
              </template>
              <b-dropdown-item aria-role="listitem" v-for="(lang, i) in this.$store.getters.getLangs" :key="`Lang${i}`" :value="lang['id']">
                {{lang['name'].toUpperCase()}}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </header>
    <section id="configurador" class="columns is-vcentered is-mobile is-multiline" v-bind:class="[aspectRadio, { fijo: fijarPuente }]">
      <div class="column is-full">
        <div class="columns is-mobile">
          <div class="column is-hidden-mobile is-hidden-tablet-only is-hidden-desktop-only is-1-widescreen has-background-white"></div>
          <div id="capa-contiene-renders" class="column is-full-mobile is-full-tablet is-8-desktop is-8-widescreen c1" v-bind:class="[aspectRadio]">
            <div class="columns is-vcentered is-mobile is-multiline m-0">
              <div id="menu-partes-desktop" class="column is-full-desktop is-hidden-mobile is-hidden-tablet-only is-hidden-desktop-only has-background-white has-text-centered is-hidden">
                <div class="menu">
                  <div class="scrolling-wrapper">
                      <div v-for="boton in botones" :class="{'opcion': true,'viewed':boton.viewed,'selected': boton.selected}" :key="'dbtn_'+boton.codigo">
                        <b-button @click="scrollTo(boton.codigo);trackEventGA('Configurador',skuactivo+'-veropcion',boton.codigo);">{{ boton.nombre[$i18n.locale]}}</b-button>
                      </div>
                  </div>
                </div>
              </div>
              <div id="menu-mobile" class="column is-10-mobile is-10-tablet is-12-desktop pr-0 has-text-centered" v-if="this.$store.getters.getPuenteLavadoActivo">
                <b-button
                  class="has-text-weight-bold pt-0 maquina-seleccionada"
                  @click="cambiaModalSelPuentes(true)">
                  {{ this.puentelavadoactivo.nombre[this.lang.replace('_','-').toLowerCase()] }}
                  <span data-v-7e947f75="" class="icon ml-1 is-hidden-desktop is-medium"><svg aria-hidden="true" data-prefix="fas" data-icon="sort-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" data-fa-i2svg="" class="svg-inline--fa fa-sort-down fa-w-16"><path fill="currentColor" d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"></path></svg><!-- <i class="fas fa-sort-down"></i> --></span>
                </b-button>
                <b-button
                  class="has-text-weight-bold pt-0 maquina-seleccionada is-hidden-mobile is-hidden-tablet-only"
                  @click="isComponentModalActive = true;trackEventGA('Configurador',skuactivo,'ver-info');"
                  type="is-ghost">
                  <b-icon
                      pack="fas"
                      icon="info-circle"
                      size="is-small">
                  </b-icon>
                </b-button>
              </div>
              <div class="info column is-2 has-text-right is-hidden-desktop">
                <b-button
                  class="has-text-weight-bold pt-0 maquina-seleccionada"
                  @click="isComponentModalActive = true;trackEventGA('Configurador',skuactivo,'ver-info');"
                  type="is-ghost">
                  <b-icon
                      pack="fas"
                      icon="info-circle"
                      size="is-small">
                  </b-icon>
                </b-button>
              </div>
              <div id="puente-configurado" class="column is-full p-0" v-if="this.$store.getters.getPuenteLavadoActivo">
                <b-carousel
                  :interval=6000
                  repeat
                  has-drag
                  animated="slide"
                  :autoplay=false
                >
                  <b-carousel-item v-if="this.$store.getters.isloading">
                    <div class="hero">
                      <div class="hero-body p-0 has-text-centered">
                        <img id="render-empty"
                            src="../assets/img/render-empty.png"
                            :class="this.$store.getters.getSKUActivo"
                            :alt="this.$store.getters.getSKUActivo +' '+ this.$i18n.t('general.FrontImage')"
                        >
                      </div>
                    </div>
                  </b-carousel-item>
                  <b-carousel-item v-show="!this.$store.getters.isloading">
                    <div class="hero">
                      <div class="hero-body p-0 has-text-centered">
                        <img id="render-front"
                            :src="this.$store.getters.getImagenFrontal"
                            :class="this.$store.getters.getSKUActivo"
                            :alt="this.$store.getters.getSKUActivo +' '+ this.$i18n.t('general.FrontImage')"
                        >
                      </div>
                    </div>
                  </b-carousel-item>
                  <b-carousel-item v-show="!this.$store.getters.isloading">
                    <div class="hero">
                      <div class="hero-body p-0 has-text-centered">
                        <img id="render-rear"
                            :src="this.$store.getters.getImagenTrasera"
                            :class="this.$store.getters.getSKUActivo"
                            :alt="this.$store.getters.getSKUActivo +' '+ this.$i18n.t('general.BackImage')"
                        >
                      </div>
                    </div>
                  </b-carousel-item>
                </b-carousel>
              </div>
            </div>
          </div>
          <div class="column is-hidden-mobile is-hidden-tablet-only is-4-desktop is-3-widescreen">
            <div class="columns is-mobile is-multiline">
              <div class="column is-full" v-bind:class="[!numPuentesMenuMasSeis ? 'is-hidden' : '']">
                <div id="compartir" class="section lateral">
                  <div class="columns is-vcentered is-mobile is-multiline">
                    <div class="column is-half pb-0">
                      <b-button type="is-rojo"
                        size="is-medium"
                        icon-left="share-variant"
                        :disabled ='this.$store.getters.isloading'
                        expanded


                        @click="isCompartirModalActive = true;trackEventGA('Configurador',skuactivo+'-compartir','mostrar');">

                        {{ this.$i18n.t('general.Share') }}
                      </b-button>
                    </div>
                    <div class="column is-half pb-0">
                      <b-button type="is-verde"
                        size="is-medium"
                        icon-left="email-outline"
                        expanded
                        @click="isAyudaModalActive = true;trackEventGA('Configurador',skuactivo+'-contacto','mostrar');">
                        {{ this.$i18n.t('general.ContactUs') }}
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
              <div id="sidebar" class="column is-hidden-mobile is-hidden-tablet-only is-full" v-if="this.$store.getters.getPuenteLavadoActivo">
                <div id="elementos-configurables" class="column is-full px-0" v-if="this.puentelavadoactivo!==null && this.puentelavadoactivo.nombre.es!==''" :key="'ec_'+this.$store.getters.getSKUActivo">

                  <div class="detalles column is-full px-0 pt-0" v-if="this.$store.getters.getPuenteLavadoActivo!==null">
                    <configuraciones :colores="this.$store.getters.getColoresCarenado" :coloresVinilo="this.$store.getters.getColoresVinilo" :configuraciones="this.$store.getters.getPuenteLavadoActivo.configuracionesestandar" :lang="$i18n.locale" :backendurl="urlbackend" :skuactivo="this.$store.getters.getSKUActivo" @registrar-cambio="registroCambio"></configuraciones>
                    <sel-color-partes parte_key="estructura" :parte="null" :colores="this.$store.getters.getColoresCarenado" :defaultcolor="this.$store.getters.getPuenteLavadoActivo.estructura.color" @registrar-cambio="registroCambio" v-if="!this.$store.getters.getPartesOcultas.some(e => e ==='estructura') || !esversionpublica"></sel-color-partes>
                    <sel-color-partes parte_key="modelos" :parte="null" :colores="this.$store.getters.getColoresCarenado" :opciones="carenados" @modelo-activo="cambioModelo" @registrar-cambio="registroCambio" :key="this.$store.getters.getSKUActivo"  v-if="!this.$store.getters.getPartesOcultas.some(e => e ==='carenado') || !esversionpublica"></sel-color-partes>
                    <div v-for="parte in partesdefault" :key="'_part_'+parte">
                      <div v-show="typeof partes[parte] !=='undefined' && partes[parte]['user-puede-modificar']" v-if="!$store.getters.getPartesOcultas.some(e => e ===parte) || !esversionpublica">

                        <sel-color-partes :parte_key="parte"
                                          :parte="partes[parte]"

                                          :colores="colores_carenado"
                                          @registrar-cambio="registroCambio"

                                          :defaultcolor="(partes[parte] !== null && 'opciones' in partes[parte] && partes[parte].opciones.length > 0) ? partes[parte].opciones.find(v => v.default === true).color : null"

                                          :lang="$i18n.locale"
                                          v-if="partes[parte].opciones[0].colorear==true">

                        </sel-color-partes>

                        <sel-opciones-partes :parte="partes[parte]"
                                           :parte_key="parte"
                                           :lang="$i18n.locale"
                                           @registrar-cambio="registroCambio"
                                           v-else
                        >
                        </sel-opciones-partes>
                      </div>
                    </div>
                    <sel-cepillos :configuracion="rodillos" :colores="colores_cepillos" :colores_publica="colores_cepillos_publica" @registrar-cambio="registroCambio" v-show="skuactivo!='Puente_Istobal_MWASH3PRO_Alto_Blanco'"></sel-cepillos>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    </section>
    <section id="configurador-2" class="columns is-vcentered is-mobile is-multiline is-hidden-desktop">
      <div id="elementos-configurables" class="column is-full px-0">
        <div class="menu">
          <div class="scrolling-wrapper">
            <div v-for="boton in botones" :class="{'opcion': true,'viewed':boton.viewed,'selected': boton.selected}" :key="'dbtn_mov_'+boton.codigo" v-show="mostrarBotonesVerMovil(boton)">
              <b-button @click="showConfig(boton.codigo);trackEventGA('Configurador',skuactivo+'-veropcion',boton.codigo);">{{ boton.nombre[$i18n.locale]}}</b-button>
            </div>
          </div>
        </div>
        <div class="detalles column is-full px-0" v-if="this.$store.getters.getPuenteLavadoActivo!==null">
          <configuraciones :colores="this.$store.getters.getColoresCarenado" :coloresVinilo="this.$store.getters.getColoresVinilo" :configuraciones="this.$store.getters.getPuenteLavadoActivo.configuracionesestandar" :lang="$i18n.locale" :backendurl="urlbackend" :skuactivo="this.$store.getters.getSKUActivo" @registrar-cambio="registroCambio" v-show="configmobile=='configuraciones'"></configuraciones>
          <sel-color-partes parte_key="estructura" :parte="null" :colores="this.$store.getters.getColoresCarenado" :defaultcolor="this.$store.getters.getPuenteLavadoActivo.estructura.color" @registrar-cambio="registroCambio" v-show="configmobile=='estructura'" v-if="!this.$store.getters.getPartesOcultas.some(e => e ==='estructura') || !esversionpublica"></sel-color-partes>
          <sel-color-partes parte_key="modelos" :parte="null" :colores="this.$store.getters.getColoresCarenado" :opciones="carenados" @modelo-activo="cambioModelo" @registrar-cambio="registroCambio" :key="this.$store.getters.getSKUActivo" v-show="configmobile=='modelos'" v-if="!this.$store.getters.getPartesOcultas.some(e => e ==='carenado') || !esversionpublica"></sel-color-partes>
          <div v-for="parte in partesdefault" :key="'_part_mob_'+parte">
            <div v-show="typeof partes[parte] !=='undefined' && partes[parte]['user-puede-modificar']" v-if="!$store.getters.getPartesOcultas.some(e => e ===parte) || !esversionpublica">
              <sel-color-partes :parte_key="parte"
                                :parte="partes[parte]"

                                :colores="colores_carenado"
                                @registrar-cambio="registroCambio"

                                :defaultcolor="(partes[parte] !== null && 'opciones' in partes[parte] && partes[parte].opciones.length > 0) ? partes[parte].opciones.find(v => v.default === true).color : null"

                                :lang="$i18n.locale"
                                v-if="partes[parte].opciones[0].colorear==true"
                                v-show="configmobile==parte"
                >

              </sel-color-partes>

              <sel-opciones-partes :parte="partes[parte]"
                                   :parte_key="parte"
                                   :lang="$i18n.locale"
                                   @registrar-cambio="registroCambio"
                                   v-show="configmobile==parte"
                                   v-else
              >
              </sel-opciones-partes>
            </div>
          </div>

          <sel-cepillos :configuracion="rodillos" :colores="colores_cepillos" @registrar-cambio="registroCambio" :colores_publica="colores_cepillos_publica" v-show="configmobile=='cepillos' && skuactivo!='Puente_Istobal_MWASH3PRO_Alto_Blanco'"></sel-cepillos>
        </div>
      </div>
    </section>
    <div id="compartir" class="section is-hidden-desktop" v-bind:class="{ fijo: fijarBotonesFooter }">
      <div class="columns is-vcentered is-mobile is-multiline">
        <div class="column is-half">
          <b-button type="is-rojo"
            size="is-medium"
            icon-left="share-variant"
            expanded
            :disabled ='this.$store.getters.isloading'
            @click="isCompartirModalActive = true;trackEventGA('Configurador',skuactivo+'-compartir','mostrar');">
            {{ this.$i18n.t('general.Share') }}
          </b-button>
        </div>
        <div class="column is-half">
          <b-button type="is-verde"
            size="is-medium"
            icon-left="email-outline"
            expanded
            @click="isAyudaModalActive = true;trackEventGA('Configurador',skuactivo+'-contacto','mostrar');">
            {{ this.$i18n.t('general.ContactUs') }}
          </b-button>
        </div>
      </div>
    </div>
    <section class="section menu-desktop is-hidden-mobile is-hidden-tablet-only" v-bind:class="[aspectRadio]">
      <div class="container is-fluid px-0">
        <div class="columns">
          <div class="column is-8-desktop is-9-widescreen has-text-centered pt-4" v-bind:class="[numPuentesMenuMasSeis ? 'is-12-desktop is-12-widescreen' : '']">
            <lista-puentes-scroll></lista-puentes-scroll>
          </div>
          <div class="column is-4-desktop is-3-widescreen" v-bind:class="[numPuentesMenuMasSeis ? 'is-hidden' : '']">
            <div id="compartir" class="section">
              <div class="columns is-vcentered is-mobile is-multiline">
                <div class="column is-half">
                  <b-button type="is-rojo"
                    size="is-medium"
                    icon-left="share-variant"
                    expanded
                    :disabled ='this.$store.getters.isloading'
                    @click="isCompartirModalActive = true;trackEventGA('Configurador',skuactivo+'-compartir','mostrar');">
                    {{ this.$i18n.t('general.Share') }}
                  </b-button>
                </div>
                <div class="column is-half">
                  <b-button type="is-verde"
                    size="is-medium"
                    icon-left="email-outline"
                    expanded
                    @click="isAyudaModalActive = true;trackEventGA('Configurador',skuactivo+'-contacto','mostrar');">
                    {{ this.$i18n.t('general.ContactUs') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="footer pb-0" v-bind:class="{ conPadding: fijarBotonesFooter }" v-observe-visibility="visibilityChanged">
      <div class="content has-text-centered">
        <p class="is-size-6">
          <a href="https://istobal.com">
          <img
            class="logo"
            src="../assets/img/ISTOBAL_Vehicle-Wash-and-Care_b.png"
            :alt="this.$i18n.t('general.istobal-logo')"
          >
          </a><br />
          {{ this.$i18n.t('general.PrivacyText') }}
        </p>
        <p class="copyright is-size-6">© ISTOBAL 2022. {{ this.$i18n.t('general.RightsReserved') }}.</p>
      </div>
    </footer>
    <b-modal
        v-model="isComponentModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-label="Info"
        aria-modal
        custom-class="info-puente">
          <div class="card px-6 pb-6">
            <div class="card-image has-text-right">
              <button
              type="button"
              class="delete mt"
              @click="isComponentModalActive = false"/>
            </div>
            <div class="card-content has-text-left pt-0">
                <div class="content pb-2" v-if="this.$store.getters.getPuenteLavadoActivo !== null">
                  <h1 class="is-size-5">{{ this.$store.getters.getPuenteLavadoActivo.nombre[$i18n.locale.replace('_','-').toLowerCase()]}}</h1>
                  <p>{{ this.$store.getters.getPuenteLavadoActivo.descripcion[$i18n.locale.replace('_','-').toLowerCase()]}}</p>
                  <p>{{ this.$store.getters.getPuenteLavadoActivo['descripcion-2'][$i18n.locale.replace('_','-').toLowerCase()]}}</p>
                  <div v-if="this.$store.getters.getPuenteLavadoActivo !== null && this.$store.getters.getPuenteLavadoActivo.configuracionesestandar.length > 0">
                    <h2 class="is-size-6">{{ this.$i18n.t('general.ConfiguracionesiQuote') }}</h2>
                    <div v-for="(csitem, i) in this.$store.getters.getPuenteLavadoActivo.configuracionesestandar" :key="'cs_item_'+i">
                      <h3 class="is-size-6">({{csitem.codigo}}) {{csitem.titulo[$i18n.locale.replace('_','-').toLowerCase()]}}</h3>
                      <ul class="m-0 p-0">
                        <li>
                          <p class="imagen has-text-centered">
                            <img :src="urlbackend+csitem.foto" :alt="csitem.titulo[$i18n.locale.replace('_','-').toLowerCase()]"/>

                          </p>


                        </li>
                      </ul>
                    </div>
                  </div>




                </div>
            </div>
        </div>
    </b-modal>
    <b-modal
        v-model="isCompartirModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        :aria-label="this.$i18n.t('general.Share')"
        aria-modal
        custom-class="modal-compartir">
          <div class="card">
            <div class="card-content has-text-centered">
                <div class="content pb-2">
                  <h4 class="is-size-5 has-text-weight-normal is-gris">{{ this.$i18n.t('general.Share') }}</h4>
                  <!--<a class="close has-text-right is-size-7">
                    <span class="has-text-centered"><img svg-inline class="icon" src="../assets/img/icon-close.svg" alt="cerrar" /></span>
                  </a>-->
                  <div class="colores compartir has-text-left">
                    <b-menu :activable="true" v-show="this.shareitems" accordion>
                      <b-menu-list ref="share-menu-list">
                        <b-menu-item icon="email-outline" label="E-mail" @click="activaMail()" :expanded.sync="shareitems.find(i => i.id=='mail').active" :active.sync="shareitems.find(i => i.id=='mail').active">
                          <template #label="props">
                            {{ this.$i18n.t('general.E-mail') }}
                            <b-icon class="is-pulled-right" :icon="props.expanded ? 'menu-down' : 'menu-up'"></b-icon>
                          </template>
                          <b-menu-item>
                            <template #label>
                              <b-field>
                                  <b-input type="email"
                                      placeholder="" v-model="emailshare">
                                  </b-input>
                              </b-field>
                              <b-button type="is-verde" expanded @click="compartirEmail()">{{ $i18n !== null ? $i18n.t('general.Send') : '' }}</b-button>
                            </template>
                          </b-menu-item>
                        </b-menu-item>
                        <b-menu-item icon="file-pdf-outline" :label="this.$i18n.t('general.DownloadPDF')" :active.sync="shareitems.find(i => i.id=='pdf').active" @click="descargarPDF()"></b-menu-item>
                        <b-menu-item icon="content-copy" :label="this.$i18n.t('general.CopyLink')" :active.sync="shareitems.find(i => i.id=='copy').active" @click="copiarEnlace()"></b-menu-item>
                      </b-menu-list>
                    </b-menu>
                  </div>
                  <b-button type="is-ghost" expanded class="py-4 is-size-5" @click="isCompartirModalActive = false;trackEventGA('Configurador',skuactivo+'-compartir','cancelar');">{{ this.$i18n.t('general.Close') }}</b-button>
                </div>
            </div>
        </div>
    </b-modal>
    <b-modal
        v-model="isAyudaModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        :aria-label="this.$i18n.t('general.Help')"
        aria-modal
        custom-class="modal-ayuda">
          <div class="card">
            <div class="card-content has-text-centered">
                <div class="content ayuda pb-2">
                  <!--<h4 class="is-size-5 has-text-weight-normal is-gris mt-1 mb-5">
                    <img
                        src.="@/assets/img/istobal-logo.png"
                        :alt="this.$i18n.t('general.istobal-logo')"
                    >
                  </h4>-->
                  <p class="mb-5"><strong>{{ this.$i18n.t('general.NeedHelp') }}</strong> {{ this.$i18n.t('general.ContactUsTitle') }}</p>
                  <b-button type="is-ghost" expanded class="py-4 is-size-5" @click="llamar();trackEventGA('Configurador',skuactivo+'-contacto','llamar');">{{ this.$i18n.t('general.CallTo') }}</b-button>
                  <b-button type="is-ghost" expanded class="py-4 is-size-5" @click="solicitarinfo();trackEventGA('Configurador',skuactivo+'-contacto','mostrar');">{{ this.$i18n.t('general.AskInformation') }}</b-button>
                  <b-button type="is-ghost" expanded class="salir py-4 is-size-5" @click="isAyudaModalActive = false;trackEventGA('Configurador',skuactivo+'-ayuda','salir');">{{ this.$i18n.t('general.Close') }}</b-button>
                </div>
            </div>
        </div>
    </b-modal>
    <b-modal
        v-model="isPrevenirSalidaModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        :aria-label="this.$i18n.t('general.Help')"
        aria-modal
        custom-class="modal-ayuda"
    >
          <div class="card">
            <div class="card-content has-text-centered">
                <div class="content ayuda prevenir pb-2">
<!--                  <h4 class="is-size-5 has-text-weight-normal is-gris mt-1 mb-5">
                    <img
                        src="../assets/img/istobal-logo.png"
                        :alt="this.$i18n.t('general.istobal-logo')"
                    >
                  </h4>-->
                  <p class="mb-5">{{ this.$i18n.t('general.ChooseAnOptionCustomRollover') }}</p>
                  <b-button type="is-ghost" expanded class="py-4 is-size-5" @click="isPrevenirSalidaModalActive = false;isCompartirModalActive = true;trackEventGA('Configurador',skuactivo+'-compartir','mostrar-prevenir-salida');">{{ this.$i18n.t('general.ShareContact') }}</b-button>
                  <b-button type="is-ghost" expanded class="py-4 is-size-5"  @click="isPrevenirSalidaModalActive = false;isContactoModalActive = true;trackEventGA('Configurador',skuactivo+'-contacto','mostrar-prevenir-salida');">{{ this.$i18n.t('general.AskInformation') }}</b-button>
                </div>
            </div>
        </div>
    </b-modal>
    <b-modal
        v-model="isMenuModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-label="Menu"
        aria-modal
        custom-class="puentes-disponibles">
          <lista-puentes></lista-puentes>

    </b-modal>
    <b-modal
        v-model="isContactoModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        :aria-label="this.$i18n.t('general.AskInformation')"
        aria-modal
        custom-class="modal-ayuda">
          <div class="card">
            <div class="card-content has-text-centered">
                <div class="content ayuda contacto pb-2">
                  <h4 class="is-size-5 has-text-weight-normal is-gris">{{ this.$i18n.t('general.AskInformation') }}</h4>
                  <iframe id="ytplayer" type="text/html" width="100%" height="400" :src="contactIframeURL" frameborder="0" allowfullscreen></iframe>
                  <b-button type="is-ghost" expanded class="py-4 is-size-5" @click="isContactoModalActive = false;isPrevenirSalidaModalActive = false;isAyudaModalActive = false;trackEventGA('Configurador',skuactivo+'-contacto','cancelar');">{{ this.$i18n.t('general.Close') }}</b-button>
                </div>
            </div>
        </div>
    </b-modal>
    <b-modal
        v-model="isAvisoModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        :aria-label="this.$i18n.t('general.Help')"
        aria-modal
        custom-class="modal-ayuda">
          <div class="card">
            <div class="card-content has-text-centered">
                <div class="content ayuda pb-2">
                  <h4 class="is-size-5 has-text-weight-normal is-gris mt-1 mb-5">
                    {{ this.$i18n.t('general.Notice') }}
                  </h4>
                  <p class="mb-5 has-text-left" v-html="this.$i18n.t('general.NoticeText')"></p>
                  <b-button type="is-ghost" expanded class="salir py-4 is-size-5" @click="isAvisoModalActive = false;trackEventGA('Configurador',skuactivo+'-avisoinicial','aceptar');">{{ this.$i18n.t('general.Aceptar') }}</b-button>
                </div>
            </div>
        </div>
    </b-modal>
    <b-loading v-model="isLoading" :can-cancel="false"></b-loading>
  </div>
</template>

<script>
import ListaPuentes from "../components/listaPuentes";
import ListaPuentesScroll from "../components/listaPuentesScroll";
import SelColorPartes from "../components/selColorPartes";
import SelOpcionesPartes from "../components/selOpcionesPartes";
import SelCepillos from "../components/selCepillos";
import configuraciones from "../components/configuraciones";
export default {
name: "Dynamic",
  components: {SelCepillos, SelOpcionesPartes, SelColorPartes, ListaPuentesScroll, ListaPuentes,configuraciones},

  props: ['pais','locale','sku','hash'],
  data () {
    return {
      isComponentModalActive: false,
      isColoresCepillosModalActive: false,
      isColoresCarenadoModalActive: false,
      isColoresViniloModalActive: false,
      isCompartirModalActive: false,
      isAyudaModalActive: false,
      isContactoModalActive: false,
      isAvisoModalActive: false,
      contactIframeURL: '/contact-es.html',
      isPrevenirSalidaModalActive: false,
      incluirLavarruedas: 'Sí',
      luminosoIncluir: 'No',
      luminoso: 'Sferic',
      pictograma: 'Silver',
      fijarBotonesFooter: false,
      scrollDirection: null,
      scrollYPosition: 0,
      fijarPuente: false,
      aspectRadio: 'aspect_16_9',
      sidebarHeight: 0,
      numPuentesMenuMasSeis: false,
      partesdefault:  ['cabut','puerta','luminoso','pictograma','luminososuperior','pictogramasuperior','lavarruedas','logo_istobal'],
      botones: [
        {codigo: 'configuraciones',nombre: {es: 'Configuraciones', en: 'Configurations', en_us: 'Configurations'}, selected: true, viewed: false},
        {codigo: 'estructura',nombre: {es: 'Estructura', en: 'Structure', en_us: 'Structure'}, selected: false, viewed: false},
        {codigo: 'modelos',nombre: {es: 'Carenado', en: 'Fairing', en_us: 'Fairing'}, selected: false, viewed: false},
        {codigo: 'cabut',nombre: {es: 'Cabeceras superiores', en: 'Front/rear fairing', en_us: 'Front/rear fairing'}, selected: false, viewed: false},
        {codigo: 'puerta',nombre: {es: 'Puertas', en: 'Doors', en_us: 'Doors'}, selected: false, viewed: false},
        {codigo: 'cepillos',nombre: {es: 'Cepillos', en: 'Brushes', en_us: 'Brushes'}, selected: false, viewed: false},
        {codigo: 'lavarruedas',nombre: {es: 'Lavarruedas', en: 'Wheel wash', en_us: 'Wheel wash'}, selected: false, viewed: false},
        {codigo: 'luminoso',nombre: {es: 'Luminosos', en: 'Lights', en_us: 'Lights'}, selected: false, viewed: false},
        {codigo: 'pictograma',nombre: {es: 'Pictogramas', en: 'Pictograms', en_us: 'Pictograms'}, selected: false, viewed: false},
        {codigo: 'luminososuperior',nombre: {es: 'Luminoso superior', en: 'Top light', en_us: 'Top light'}, selected: false, viewed: false},
        {codigo: 'pictogramasuperior',nombre: {es: 'Pictograma superior', en: 'Top pictogram', en_us: 'Top pictogram'}, selected: false, viewed: false},
        //{codigo: 'carenado-posterior',nombre: {es: 'Carenado Posterior', en: 'Carenado Posterior', en_us: 'Carenado Posterior'}, selected: false, viewed: false},


      ],
      configmobile : 'configuraciones',
      shareitems: [
        { id: 'mail', active: false},
        { id: 'pdf', active: false},
        { id: 'copy', active: false},
      ],
      emailshare: '',
      umbralcambios: process.env.VUE_APP_UMBRAL_CAMBIOS,
      urlbackend: process.env.VUE_APP_BACKEND_SERVER,
      urlfrontedn: process.env.VUE_APP_URL,
      esversionpublica: process.env.VUE_APP_ES_PUBLIC == 1 ? true : false,
      debugMode: process.env.VUE_APP_DEBUGMODE == 1 ? true : false

    }
  },
  computed: {
    isMenuModalActive: {
      get() {
        return this.$store.getters.getIsMenuModalActive
      },
      set(value) {
        this.$store.commit('setIsMenuModalActive', value)
      }
    },
    localeselector : {
      get() {
        return this.locale.toLowerCase().replace('-','_')
      },
      set(value){
        this.$i18n.locale=value.toLowerCase().replace('-','_')
      }
    },
    puentelavadoactivo: function() {
      if (this.$store.getters.getPuenteLavadoActivo !== null){
        return this.$store.getters.getPuenteLavadoActivo
      }else{
        return null
      }
    },
    skuactivo: function() {
      return this.$store.getters.getSKUActivo
    },
    carenados : function () {
      return this.puentelavadoactivo.modelos.map(val => { return { 'nombre': val.nombre[this.$i18n.locale.replace('_','-').toLowerCase()], 'selected': val.default, 'codigo': val.codigo }});
    },
    partes : function () {
            if (this.puentelavadoactivo){
              if (this.puentelavadoactivo.modelos.length > 1){
                if (this.debugMode === true) console.log('Puente activo. Más de un modelo.');
                return this.puentelavadoactivo.modelos.filter(modelo => modelo.default == true)[0]['partes']
              } else{
                if (this.debugMode === true) console.log('Puente activo. Solo un modelo.');
                return this.puentelavadoactivo.modelos[0].partes
              }
            }else{
              if (this.debugMode === true) console.log('Puente no activo. No tengo partes');
              return null
            }


    },
    colores_carenado: function () {
      return this.$store.getters.getColoresCarenado
    },
    colores_cepillos: function () {
      return this.$store.getters.getColoresCepillos
    },
    colores_cepillos_publica: function () {
      return this.$store.getters.getColoresCepillosPublica
    },
    colores_vinilo: function () {
      return this.$store.getters.getColoresVinilo
    },
    colores_vinilo_publica: function () {
      return this.$store.getters.getColoresViniloPublica
    },
    isLoading: function () {
      return this.$store.getters.isloading
    },
    rodillos : function () {
      return this.$store.getters.getPuenteLavadoActivo.rodillos
    },
    lang: function (){
      return this.$i18n.locale
    },
    contadorcambios: function (){
      return this.$store.getters.getCambiosContabilizados
    },
    mostrarconfigestandar: function (){
      if (this.$route.name == 'Home' && this.$store.getters.getCambiosContabilizados == 2){
        return true;
      }else if (this.$route.name !== 'Home' && this.$store.getters.getCambiosContabilizados == 2){
        return true;
      }else{
        return false;
      }

    },

    puenteDefault : function (){
       return this.$store.getters.getPuenteDefault
    },

    numeropuentes : function (){
      return this.$store.getters.getPuentes ? this.$store.getters.getPuentes.length : 0
    },









  },
  beforeMount: function() {
    this.$store.commit('setSolicitar', false)
  },
  mounted: function() {
    this.$gtm.trackView("Home", "/");

    if(/budget/.test(window.location.href)){
      this.solicitarinfo()
    }
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
    this.$nextTick(function(){
      this.$store.commit('setSolicitar', true)
    })
    this.$i18n.locale = this.locale.toLowerCase().replace('-','_')
    this.contactIframeURL = this.$i18n.t('general.ContactUsIframeURL_'+this.pais+'_'+ this.$i18n.locale);

    /*if (this.$i18n.locale!="en_us"){
      this.numPuentesMenuMasSeis=true
    }else{
      this.numPuentesMenuMasSeis=false
    }*/
    //console.log('El parametro sku es' +this.sku)

    if (typeof this.sku !== 'undefined'){
      //console.log('CARGAMOS LA MAQUINA CON SKU: ' + this.sku)
      this.$store.dispatch('getConfigPuenteFromBackend',this.sku)
    }

    if (typeof this.hash !== 'undefined'){
      //console.log('Cargamos configuracion hash:'+ this.hash)
      this.$store.dispatch('getConfigWithHash',this.hash)
    }

    this.handleResize()
  },
  created(){
    window.addEventListener("beforeunload", this.preventNav)


  },
  beforeDestroy(){
    window.addEventListener("beforeunload", this.preventNav)
  },
  destroyed: function() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    llamar(){
      window.location ='tel:'+this.$i18n.t('general.CallToPhone');
    },
    handleScroll: function() {
      if (window.innerWidth < 769){
        var scrollY = window.scrollY
        //console.log('hola ??')
        var headerHeight = document.getElementById('header').clientHeight;
        var configuradorHeight = document.getElementById('configurador').clientHeight;

        if (scrollY > this.scrollYPosition) {
          this.scrollDirection = 'down';
          this.fijarBotonesFooter = false;
          if (scrollY > headerHeight){
            this.fijarPuente = true;
            document.getElementsByTagName("BODY")[0].style.paddingTop = configuradorHeight + "px";
          }
        } else {
          this.scrollDirection = 'up';
          if (window.innerHeight)
          this.fijarBotonesFooter = true;
          if (scrollY <= headerHeight){
            this.fijarPuente = false;
            document.getElementsByTagName("BODY")[0].style.paddingTop = "0px";
          }
        }
        this.scrollYPosition = scrollY;
      }
    },
    aspectRadioGET (a, b) {
            return (b == 0) ? a : this.aspectRadioGET (b, a%b);
    },
    handleResize() {
      var aspect = this.aspectRadioGET(window.innerWidth,window.innerHeight)
      var aspectPersonalizado = ["aspect_512_683","aspect_512_627","aspect_16_9","aspect_4_3","aspect_683_512","aspect_8_5","aspect_683_384","aspect_384_199"]
      this.aspectRadio = 'aspect_' + window.innerWidth/aspect + "_" + window.innerHeight/aspect;
      this.elementReady('#sidebar').then((sidebar)=>{
        this.sidebarHeight = sidebar.clientHeight;
        if (this.sidebarHeight<50) this.sidebarHeight = 700;
        var nuevoAlto = Math.round(this.sidebarHeight*1.3);
        var nuevoMargin = Math.round(this.sidebarHeight*0.4);
        if (aspectPersonalizado.includes(this.aspectRadio)!==true && window.innerWidth > 768){
          //console.log('No personalizado: '+this.aspectRadio)
          if (window.innerWidth>=window.innerHeight){
            //alert('pantalla ancha'+window.innerWidth+':'+window.innerHeight)
            this.elementReady('#render-front').then((renderFront)=>{
              renderFront.style.height = nuevoAlto+"px";
              renderFront.style.width = "auto";
              if (typeof this.skuactivo !=='undefined' && (this.skuactivo.includes("Extended") || (this.skuactivo.includes("3PRO") && this.pais == 'us'))){//Las máquinas extended son muy altas y se cortan.
                if (this.debugMode === true) console.log('Retoco margin extended');
                nuevoAlto = Math.round(this.sidebarHeight*1.2);
                renderFront.style.height = nuevoAlto+"px";
                renderFront.style.marginTop = "-"+(nuevoMargin-140)+"px";
              }else{
                //console.log('No extended');
                renderFront.style.marginTop = "-"+nuevoMargin+"px";
              }
              renderFront.style.maxWidth = "none";
            });
            this.elementReady('#render-rear').then((renderRear)=>{
              renderRear.style.height = nuevoAlto+"px";
              renderRear.style.width = "auto";
              if (typeof this.skuactivo !=='undefined' && (this.skuactivo.includes("Extended") || this.skuactivo.includes("3PRO"))){//Las máquinas extended son muy altas y se cortan.
                if (this.debugMode === true) console.log('Retoco margin 3PRO');
                renderRear.style.height = nuevoAlto+"px";
                renderRear.style.marginTop = "-"+(nuevoMargin-140)+"px";
              }else{
                if (this.debugMode === true) console.log('Retoco margin: sin SKU');
                renderRear.style.marginTop = "-"+nuevoMargin+"px";
              }
              renderRear.style.maxWidth = "none";
            });
          }else{
            this.elementReady('#render-front').then((renderFront)=>{
              renderFront.style.height = "auto";
              renderFront.style.width = "100%";
              renderFront.style.marginTop = "-6rem";
              renderFront.style.maxWidth = "100%";
            });
            this.elementReady('#render-rear').then((renderRear)=>{
              renderRear.style.height = "auto";
              renderRear.style.width = "100%";
              renderRear.style.marginTop = "-6rem";
              renderRear.style.maxWidth = "100%";
            });
          }
        }else if (window.innerWidth > 768){
          //alert('Personalizado: '+this.aspectRadio+' ; '+window.innerWidth)
          if (typeof document.getElementById("render-front") !=='undefined'){
            document.getElementById("render-front").style.height = "auto";
            document.getElementById("render-front").style.width = "100%";
            document.getElementById("render-rear").style.height = "auto";
            document.getElementById("render-rear").style.width = "100%";
            var aspectPersonalizadoMarginTop = false;
            if (typeof this.skuactivo !=='undefined' && (this.skuactivo.includes("Extended") || this.skuactivo.includes("3PRO"))){//Las máquinas extended son muy altas y se cortan.
              aspectPersonalizadoMarginTop = {
                  aspect_512_683: { marginTop: '-4vh', width: '90%'},
                  aspect_512_627: { marginTop: '-4vh', width: '90%'},
                  aspect_16_9: { marginTop: '-17vh', width: '85%'},
                  aspect_4_3: { marginTop: '-14vh', width: '90%'},
                  aspect_683_512: { marginTop: '-14vh', width: '90%'},
                  aspect_8_5: { marginTop: '-18vh', width: '90%'},
                  aspect_683_384: { marginTop: '-22vh', width: '90%'},
                  aspect_384_199: { marginTop: '-27vh', width: '90%'}
              }
            }else{
              aspectPersonalizadoMarginTop = {
                  aspect_512_683: { marginTop: '-13vh', width: '100%'},
                  aspect_512_627: { marginTop: '-13vh', width: '100%'},
                  aspect_16_9: { marginTop: '-37vh', width: '100%'},
                  aspect_4_3: { marginTop: '-26vh', width: '100%'},
                  aspect_683_512: { marginTop: '-26vh', width: '100%'},
                  aspect_8_5: { marginTop: '-31vh', width: '100%'},
                  aspect_683_384: { marginTop: '-37vh', width: '100%'},
                  aspect_384_199: { marginTop: '-41vh', width: '100%'}
              }
            }
            document.getElementById("render-front").style.width = ""+aspectPersonalizadoMarginTop[this.aspectRadio]['width']+"";
            document.getElementById("render-rear").style.width = ""+aspectPersonalizadoMarginTop[this.aspectRadio]['width']+"";
            document.getElementById("render-front").style.marginTop = ""+aspectPersonalizadoMarginTop[this.aspectRadio]['marginTop']+"";
            document.getElementById("render-rear").style.marginTop = ""+aspectPersonalizadoMarginTop[this.aspectRadio]['marginTop']+"";
          }
        }else{//Por si paso de desktop a mobile
            document.getElementById("render-front").style.height = "auto";
            document.getElementById("render-front").style.width = "auto";
            document.getElementById("render-rear").style.height = "auto";
            document.getElementById("render-rear").style.width = "auto";
            document.getElementById("render-front").style.maxWidth = "100%";
            document.getElementById("render-rear").style.maxWidth = "100%";
            if (typeof this.skuactivo !=='undefined' && (this.skuactivo.includes("Extended") || this.skuactivo.includes("3PRO"))){//Las máquinas extended son muy altas y se cortan.
              if (this.skuactivo.includes("3PRO")){//La MWASH3pro está entre la extend y las demás.
                document.getElementById("render-front").style.marginTop = "-3rem";
                document.getElementById("render-rear").style.marginTop = "-3rem";
              }else{
                document.getElementById("render-front").style.marginTop = "-4rem";
                document.getElementById("render-rear").style.marginTop = "-4rem";
              }
            }else{
              document.getElementById("render-front").style.marginTop = "-6rem";
              document.getElementById("render-rear").style.marginTop = "-6rem";
            }
        }
      });
      //console.log('Configurador=> alto disponible:' + document.getElementById('capa-contiene-renders').clientHeight + ' -> posicionY: ' + document.getElementById('capa-contiene-renders').offsetTop + ' ; ');
      //console.log('Render=> alto disponible:' + document.getElementById('render-front').clientHeight + ' -> posicionY: ' + document.getElementById('render-front').offsetTop + ' ; ');
      //console.log('Render=> alto disponible:' + document.getElementById('render-front').clientHeight + ' -> posicionY: ' + document.getElementById('render-front').offsetTop + ' ; ');
      //alert(aspect + ' w=' + window.innerWidth + ' h=' + window.innerHeight + ' -> ' + this.aspectRadio);
    },
    preventNav(event) {
       this.trackEventGA('Configurador',this.skuactivo+'-salir','mostrar-aviso');
      //if (this.isPrevenirSalidaModalActive!==true){
        // Cancel the event
        event.preventDefault()
        // Chrome requires returnValue to be set
        this.isPrevenirSalidaModalActive=true;
        event.returnValue = ''
      //}
    },
    visibilityChanged (isVisible, entry) {
      this.isVisible = isVisible
      if (entry.target.nodeName=='FOOTER' && this.isVisible && this.fijarBotonesFooter===true){
        this.fijarBotonesFooter=false;
      }

      //console.log(entry.target.nodeName)
      //console.log(entry)
      //console.log(this)
    },
    scrollTo(elementID){
      //console.log('Click ScrollTo')
      //console.log('scroll a ' + elementID);
      this.botones.forEach(v => v.selected = false)
      this.botones.find(v => { return v.codigo ==elementID}).selected = true
      var myElement = document.getElementById(elementID);
      var topPos = myElement.offsetTop - 150;
      document.getElementById('sidebar').scrollTop = topPos;
      //document.getElementById(elementID).scrollIntoView();
    },
    showConfig(elementID){
      this.botones.forEach(v => v.selected = false)
      this.botones.find(v => { return v.codigo ==elementID}).selected = true
      this.configmobile = elementID
    },
    cambiaModalSelPuentes(val){
      this.$store.commit('setIsMenuModalActive',val)
    },
    cambioModelo(nombre){
      this.$store.dispatch('changeModeloDefault',nombre)

      this.trackEventGA("Configurador",this.skuactivo+"-cambio-carenado",nombre);

      let variaciones = this.$store.getters.getVariaciones
      variaciones.forEach(v => {
        // eslint-disable-next-line no-prototype-builtins
        if (v.hasOwnProperty('opcion')){
          v.opcion = nombre
        }
      })
      this.$store.commit('addCambiosContabilizados')
      this.$store.commit('setVariaciones',variaciones)
      //this.$store.dispatch('solicitarImagenes')
      //console.log(nombre)
      this.handleResize()
    },
    async registroCambio(cambio, enviarTrackeo = true){

      if (!this.$store.getters.getFirstLoadImage){
        if (this.debugMode === true) console.log('Registro cambio solicitado por el usuario: ')
        if (cambio.parte =='cepillo'){
          if (this.debugMode === true) console.log('Cargando cepillos ')
          this.botones.find(v => { return v.codigo =='cepillos'}).viewed = true
        }else{
          if (this.debugMode === true) console.log('Cargando parte ' + cambio.parte)
          if (this.botones.some(b => b.codigo === cambio.parte)){
            this.botones.find(v => { return v.codigo ==cambio.parte}).viewed = true
          }

        }
      }
      if (this.debugMode === true) console.log(JSON.stringify(cambio))

      if (cambio.parte == 'cepillo' && cambio.cambio == 'tipo') {
        this.$store.commit('setTipoRodillos', cambio.valor)
      }

      this.$store.commit('addCambiosContabilizados')

      await this.$store.dispatch('registrarVariacion',cambio)

      if (enviarTrackeo){
        this.trackEventGA("Configurador",this.skuactivo+"-cambio"+cambio.cambio+"-"+cambio.parte,cambio.valor);
      }

    },
    solicitarinfo(){

      this.isContactoModalActive = true;
      this.$store.dispatch('getConfigWithHash',this.$store.getters.getConfigHash)


    },
    trackEventGA(categoria,accion,label){
      this.$gtm.trackEvent({
        event: 'configurador-evento', // Event type [default = 'interaction'] (Optional)
        category: categoria,
        action: accion,
        label: label,
        noninteraction: false
      });
    },
    descargarPDF(){
      this.shareitems.forEach(i => i.active=false);
      this.shareitems.find(i => i.id=='pdf').active=true
      this.trackEventGA('Configurador',this.skuactivo+'-compartir','pdf');
      this.$store.dispatch('getPDFWithHash',this.$store.getters.getConfigHash)

      this.isCompartirModalActive = false;
      this.shareitems.forEach(i => i.active=false);


    },
    copiarEnlace(){
      this.shareitems.forEach(i => i.active=false);
      this.shareitems.find(i => i.id=='copy').active=true
      this.trackEventGA('Configurador',this.skuactivo+'-compartir','url');
      this.$store.commit('setShareLink',this.$store.getters.getConfigHash)
      const el = document.createElement('textarea');
      el.value = this.$store.getters.getShareLink;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
        this.$buefy.toast.open({
          duration: 5000,
          message: this.$i18n.t('general.clipboardLink'),
          type: 'is-success'

        });
      }
      this.isCompartirModalActive = false;
      this.shareitems.forEach(i => i.active=false);

    },
    activaMail(){
      this.shareitems.forEach(i => i.active=false);
      this.shareitems.find(i => i.id=='mail').active=true

    },
    compartirEmail(){


      if (this.validateEmail(this.emailshare)){
        this.trackEventGA('Configurador',this.skuactivo+'-compartir','email');

        this.$buefy.toast.open({
          duration: 5000,
          message: this.$i18n.t('general.emailSending')+this.emailshare,
          type: 'is-success'

        });
        this.$store.dispatch('sendEmail',this.emailshare).then(result =>{
          if (result==0){
            this.$buefy.toast.open({
              duration: 5000,
              message: this.$i18n.t('general.emailSent'),
              type: 'is-success'
            });
            this.isCompartirModalActive = false;
            this.shareitems.forEach(i => i.active=false);
            this.shareitems.find(i => i.id=='mail').active=false
          }else{
            this.$buefy.toast.open({
              duration: 5000,
              message: this.$i18n.t('general.emailError'),
              type: 'is-danger'

            });

          }
          this.emailshare = ''
        })
      }else{
        this.$buefy.toast.open({
          duration: 5000,
          message: this.$i18n.t('general.emailFormat'),
          type: 'is-danger'

        });

      }



    },
    validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  },
  elementReady(selector) {
    return new Promise((resolve) => {
      let el = document.querySelector(selector);
      if (el) {resolve(el);}
      new MutationObserver((mutationRecords, observer) => {
        // Query for elements matching the specified selector
        Array.from(document.querySelectorAll(selector)).forEach((element) => {
          resolve(element);
          //Once we have resolved we don't need the observer anymore.
          observer.disconnect();
        });
      })
        .observe(document.documentElement, {
          childList: true,
          subtree: true
        });
    });
  },
  mostrarBotonesVerMovil(boton){
      if (!this.esversionpublica){
        return true;
      }else if (boton.codigo=='configuraciones' || boton.codigo=='cepillos'){
        if (this.skuactivo=='Puente_Istobal_MWASH3PRO_Alto_Blanco'){
          return false;
        }else {
          return true;
        }
      }else if(boton.codigo=='modelos' && !this.$store.getters.getPartesOcultas.some(e => e ==='carenado') && this.esversionpublica){

        return true

      }else if (!this.$store.getters.getPartesOcultas.some(e => e === boton.codigo) && this.esversionpublica){
        if (this.partes){
          if (this.debugMode === true) console.log('Tengo partes');
          if (typeof this.partes[boton.codigo] !=='undefined' && this.partes[boton.codigo]['user-puede-modificar']){
            return true;
          }else{
            return false;
          }
        }else{
            if (this.debugMode === true) console.log('No tengo partes');
        }

      }

    }


  },
  watch: {

    skuactivo: function (newSKU) {

      this.botones.forEach(v=>{v.viewed=false; v.selected=false})
      this.$store.dispatch('aplicarConfiguracion',null)
      this.trackEventGA("Configurador",newSKU,"seleccionado");
    },
    lang: function (newLang) {
      if (newLang !== this.locale){
        //console.log('Cambiando el idioma:' + newLang)
        if (typeof this.sku !=='undefined'){
          this.$router.replace( '/'+this.$route.params.pais+'/'+newLang+'/'+this.sku)
        }else{
          this.$router.replace( '/'+this.$route.params.pais+'/'+newLang)

        }

        this.contactIframeURL = this.$i18n.t('general.ContactUsIframeURL_'+this.pais+'_'+ newLang);
      }


    },
    isCompartirModalActive: function(newVal){
      if (newVal===true){
        //console.log('Modal Compartir Activo !!')
        this.shareitems.forEach(i => i.active=false);

      }
    },
    contadorcambios: function (newVal){
      if (newVal > 0 &&  newVal % this.umbralcambios == 0 ){
        this.$store.commit('setCambiosContabilizados',0)
        //console.log('Hemos llegado al umbral de cambios: ' + newVal)
        this.isAyudaModalActive = true
      }
      this.handleResize()
    },
    mostrarconfigestandar: function (newVal){
      if (newVal==true){
        //this.isComponentModalActive = true
      }
    },
    puenteDefault: function(newVal){
      if (newVal!=='' && typeof this.sku == 'undefined'){

        this.$store.dispatch('getConfigPuenteFromBackend',newVal)
      }
    },

    numeropuentes: function(num){
      if (num > 6){
        this.numPuentesMenuMasSeis = true
      }else{
        this.numPuentesMenuMasSeis = false

      }
    }




  }

}
</script>

<style scoped>

</style>
